<template>
  <div class="calendar-view">
    <div class="months">
      <a role="button" class="month-nav" @click="prevMonth">&lt;</a>
      <div class="month-text">{{ month | text_month }}</div>
      <a role="button" class="month-nav" @click="nextMonth">&gt;</a>
    </div>
    <div class="weekdays">
      <div v-for="(val, idx) in weekdays" :key="idx" class="weekday">{{ val }}</div>
    </div>
    <ul class="days">
      <li v-for="day in days" :key="day.date" :class="{ day: true, active: day.date === (date || today), outside: day.outside }">
        <a role="button" class="day-button" @click="selectDate(day)">{{ day.text }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { CHANGE_DATE } from '@/store/calendar/types';
import mixinDatetime from '@/mixins/datetime';
import mixinFormatters from '@/mixins/formatters';

const { mapState, mapActions } = createNamespacedHelpers('calendar');

const weekdays = [
    '一', '二', '三', '四', '五', '六', '日',
];

export default {
    name: 'CalendarView',
    data() {
        const today = this.getToday(true);

        return {
            today,
            month: this.getMonth(this.date || today),
            weekdays,
        };
    },
    computed: {
        ...mapState([
            'date',
        ]),
        days() {
            const year = this.month.getFullYear();
            const month = this.month.getMonth();
            const monthFirstDay = new Date(year, month, 1);
            const monthLastDay = new Date(year, month + 1, 0);
            // const weekday = (this.month.getDay() + 6) % 7;
            const daysInMonth = monthLastDay.getDate();

            // date list
            const dates = [];
            const packDate = (date, outside = false) => ({
                text: date.getDate(),
                date: this.formatISODate(date),
                outside,
            });

            // previous
            const monthFirstWeekday = (monthFirstDay.getDay() + 6) % 7;
            for (let i = 0; i < monthFirstWeekday; i += 1) {
                const date = new Date(year, month, -i);
                dates.unshift(packDate(date, true));
            }

            // current
            for (let i = 1; i <= daysInMonth; i += 1) {
                const date = new Date(year, month, i);
                dates.push(packDate(date));
            }
            // next
            const monthLastWeekday = (monthLastDay.getDay() + 6) % 7;
            const nextMonthDays = 6 - monthLastWeekday;
            for (let i = 1; i <= nextMonthDays; i += 1) {
                const date = new Date(year, month + 1, i);
                dates.push(packDate(date, true));
            }

            return dates;
        },
    },
    methods: {
        ...mapActions({
            changeDate: CHANGE_DATE,
        }),
        getMonth(date) {
            const dateDate = new Date(date);
            return new Date(dateDate.getFullYear(), dateDate.getMonth(), 1);
        },
        prevMonth() {
            // 不能早于本月
            if (this.month.getTime() === this.getMonth(this.today).getTime()) {
                return;
            }

            this.month = new Date(this.month.getFullYear(), this.month.getMonth() - 1, 1);
        },
        nextMonth() {
            this.month = new Date(this.month.getFullYear(), this.month.getMonth() + 1, 1);
        },
        selectDate(day) {
            const date = day.date;
            // 刷新月视图
            this.month = this.getMonth(date);

            this.changeDate({
                date,
            });
        },
    },
    filters: {
        text_month(date) {
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            month = `${month}`.padStart(2, '0');

            return `${year}/${month}`;
        },
    },
    mixins: [
        mixinDatetime,
        mixinFormatters,
    ],
};
</script>

<style lang="scss" scoped>
.calendar-view {
    display: flex;
    flex-direction: column;
    background-color: white;
    font-size: 3.333333333vw;
}

.months {
    height: 17.333333333vw;
    flex: none;
    padding: 0 8vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.month-nav {
    width: 6vw;
    height: 6vw;
    line-height: 6vw;
    text-align: center;
    color: #ffd5c7;
}
.weekdays {
    height: 9.333333333vw;
    flex: none;
    background-color: #fcebe5;
    box-shadow: inset 0 -1px 0 0 #dadada;
    font-size: 2.666666667vw;
    color: #ed9c7f;
    padding: 0 4vw;
    display: flex;
    align-items: center;
}

.weekday {
    width: 14.285714286%;
    flex: auto;
    text-align: center;
}

.days {
    padding: 0 4vw;
    list-style: none;
    display: flex;
    flex-flow: row wrap;
}

.day {
    width: 14.285714286%;
    flex: auto;
    height: 16vw;
    box-sizing: border-box;
    padding-top: 4vw;
}

.day-button {
    margin: 0 auto;
    width: 8vw;
    height: 8vw;
    text-align: center;
    line-height: 8vw;
    border-radius: 100%;
    color: #717171;

    .outside > & {
        color: #c6c6c6;
    }

    .active > & {
        background-color: #ff7245;
        color: white;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/calendar/CalendarView.vue